import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatWindow = _resolveComponent("ChatWindow")!

  return (_openBlock(), _createBlock(_component_ChatWindow, {
    "is-open": $props.isOpen,
    title: $setup.chatConfig.title,
    "user-avatar": $setup.avatar,
    "question-suggestions": $setup.chatConfig.questionSuggestions,
    messages: $setup.messages,
    "is-pending-answer": $setup.isLoading,
    "signed-ai-disclaimer": $setup.signedAiDisclaimer,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    onSubmit: $setup.handleSubmit
  }, null, 8 /* PROPS */, ["is-open", "title", "user-avatar", "question-suggestions", "messages", "is-pending-answer", "signed-ai-disclaimer", "onSubmit"]))
}